import deleteRequestNetworkAction from '../../../../network/actions/delete-request'
import REDUX_ACTION from '../../../../redux/constants/action'

/**
 * Sets the given `path` status as success and set the data.
 * @private
 * @param {Object} action
 *        {Object} action.payload
 *        {string} [action.payload.path]
 *        {string} [action.payload.domainListPath]
 *        {Object} [action.payload.data]
 */
export default function loadSuccessReduxAction (action) {
  return (dispatch) => {
    // loadSuccessReduxActionLogger.debug(action)
    dispatch(deleteRequestNetworkAction(action))
    dispatch({
      type: action.type + '_SUCCESS',
      payload: action.payload,
      reduxType: REDUX_ACTION.LOAD_SUCCESS
    })
  }
}
